// extracted by mini-css-extract-plugin
export default {"container":"Options_container__CKWak","option":"Options_option__rGHsf"};